import { Injectable } from '@angular/core';
import { BackendService } from '../new-http/backend.service';
import { ILive, ITraderInfo } from '../../interfaces/lives.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LiveService extends BackendService {
  public getLives(start: string, end: string): Observable<ILive[]> {
    return this.api.get(
      `/dynamic-screens/v1/lives/trader?beginAt=${start}&endAt=${end}`
    );
  }

  public getTrader(): Observable<ITraderInfo> {
    return this.api.get(`/trader`);
  }
}
